import { render, staticRenderFns } from "./whatsapp-chat.components.vue?vue&type=template&id=24045cbe"
import script from "./whatsapp-chat.components.vue?vue&type=script&lang=js"
export * from "./whatsapp-chat.components.vue?vue&type=script&lang=js"
import style0 from "./whatsapp-chat.components.vue?vue&type=style&index=0&id=24045cbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports